module.exports = __webpack_public_path__ + "static/media/logo_reecall_2020.5b6f914c.svg";